"use client"

import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { FAQsContentProps, FAQsProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import React, { useState } from "react"
import { twMerge } from "tailwind-merge"

// Component con chỉ chịu trách nhiệm render FAQs
export const FAQsContent: React.FC<FAQsContentProps> = ({ id, className, faqs, responsiveCSS }) => {
  const [openItems, setOpenItems] = useState<string[]>([])

  if (!faqs || faqs.length === 0) {
    return (
      <>
        {responsiveCSS}
        <div className={twMerge("py-20 text-center", className)} id={id}>
          <p className="text-gray-500">Chưa có câu hỏi nào được thêm.</p>
        </div>
      </>
    )
  }

  return (
    <>
      {responsiveCSS}
      <div className={twMerge("p-0", className)} id={id}>
        <div className="mx-auto max-w-[82.5rem] sm:pr-4">
          <div className="bg-white rounded-lg">
            <Accordion type="multiple" value={openItems} onValueChange={setOpenItems} className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="!border-t border-gray-200 !border-b-0">
                  <AccordionTrigger className="sm:pr-6 py-5 text-left hover:no-underline hover:bg-gray-50 transition-colors">
                    <span className="text-sm sm:text-base font-medium text-[#393939] pr-8">{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 pt-2">
                    <div
                      className="text-sm text-[#0E101A] leading-6 prose prose-sm max-w-none"
                      dangerouslySetInnerHTML={{ __html: faq.answer || "" }}
                    />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  )
}

// RenderConfig chính – giữ nguyên cấu trúc Puck yêu cầu
export const RenderConfig: ComponentConfig<FAQsProps> = {
  render: ({ className, styles, responsiveType, faqs = [] }) => {
    const id = `faqs-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return <FAQsContent id={id} className={className} faqs={faqs} responsiveCSS={responsiveCSS} />
  },
}
